'use client';

import { type ComponentPropsWithRef, type ReactNode } from 'react';

import {
  Button,
  type ButtonMode,
  type MicroShapeVariant,
  type MicroSize,
} from '@repo/ui/Button';
import { Icon } from '@repo/ui/Icon';
import { type IconNames } from '@repo/ui/Icon/utils';
import { VisuallyHidden } from '@repo/ui/VisuallyHidden';

export interface MicroButtonProps extends ComponentPropsWithRef<'button'> {
  ariaDisabled?: boolean;
  className?: string;
  disabled?: boolean;
  icon: IconNames;
  isLoading?: boolean;
  label: string | ReactNode;
  loadingLabel?: string;
  mode?: ButtonMode;
  size?: MicroSize;
  variant?: MicroShapeVariant;
}

export const MicroButton = (props: MicroButtonProps) => {
  const {
    disabled = false,
    icon,
    isLoading = false,
    label,
    size = 'sm',
    variant = 'secondary',
    ...attrs
  } = props;

  return (
    <Button
      disabled={disabled}
      isLoading={isLoading}
      shape="micro"
      size={size}
      variant={variant}
      {...attrs}
    >
      <Icon name={icon} size={size} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </Button>
  );
};
